import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, Typography } from "@material-ui/core";
import RestoreIcon from '@material-ui/icons/Restore';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import TimelineIcon from '@material-ui/icons/Timeline';
import { TooltipTop as CustomTooltip } from "../../../Common/CustomTooltips";
import maxSpeedIcon from "../../../../images/maxSpeedIcon.png";
import diameterIcon from "../../../../images/diameterIcon.png";
import styles from "./styles";
import t from "../../../../languages/pl";

const useStyles = makeStyles(theme => styles(theme, ({ })));

const Route = props => {
    const { name, startTime, finishTime, distance, maxSpeed, averageSpeed, } = props;
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <React.Fragment>
            <div className={classes.location}>
                <CustomTooltip title={t.routeDuration}>
                    <RestoreIcon />
                </CustomTooltip>
                &nbsp;<Typography
                    variant="body2"
                >
                    {startTime}-{finishTime}
                </Typography>
            </div>
            <div className={classes.location}>
                <CustomTooltip title={t.driver}>
                    <AssignmentIndIcon />
                </CustomTooltip>&nbsp;
                <Typography
                    variant="body2"
                >
                    {name}
                </Typography>
            </div>
            <div className={classes.location}>
                <CustomTooltip title={t.routePartLength}>
                    <TimelineIcon />
                </CustomTooltip>&nbsp;
                <Typography
                    variant="body2"
                >
                    {distance === 0 ? '<1' : distance} km
                </Typography>
                <CustomTooltip title={t.maximumSpeed}>
                    <img src={maxSpeedIcon} alt="Max speed" className={classes.icon} />
                </CustomTooltip>
                &nbsp;
                <Typography
                    variant="body2"
                >
                    {maxSpeed} km/h
                </Typography>
                <CustomTooltip title={t.averageSpeed}>
                    <img src={diameterIcon} alt="Average speed" className={classes.icon} style={{width: 20, height: 20}} />
                    {/* <ShutterSpeedIcon style={{ marginLeft: theme.spacing(1) }} /> */}
                </CustomTooltip>
                &nbsp;
                <Typography
                    variant="body2"
                >
                    {averageSpeed} km/h
                </Typography>
            </div>
        </React.Fragment>
    );
};

Route.propTypes = {
    name: PropTypes.string,
    startTime: PropTypes.string,
    finishTime: PropTypes.string,
    distance: PropTypes.number,
    maxSpeed: PropTypes.number,
    averageSpeed: PropTypes.number,
};

export default Route;
